import { define } from 'wicked-elements'
import { bus } from '../../bus.js'

define('[data-map-hovers]', {
  init () {
    this.children = [...this.element.querySelectorAll('[data-uuid]')]
    this.handleMouseenter = this.handleMouseenter.bind(this)
    this.handleMouseleave = this.handleMouseleave.bind(this)
  },
  connected () {
    this.children.forEach(element => {
      element.addEventListener('mouseenter', this.handleMouseenter)
      element.addEventListener('mouseleave', this.handleMouseleave)
    });
  },
  disconnected () {
    this.children.forEach(element => {
      element.removeEventListener('mouseenter', this.handleMouseenter)
      element.removeEventListener('mouseleave', this.handleMouseleave)
    });
  },
  handleMouseenter (e) {
    const uuid = e.currentTarget?.dataset?.uuid?.trim()
    if (uuid) {
      bus.emit('map:setactive', [uuid])
    }
  },
  handleMouseleave () {
    bus.emit('map:clearactive')
  }
})